module.exports = __webpack_public_path__ + "media/app/google-play-badge-nl-fb87deb6.svg";